// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"bfcdc727","585":"85843981"}[chunkId] + ".chunk.js";
};